import React from "react";
import styled from "styled-components/macro";

import { addFormCopy } from "../../../shared/probateEstate/estateItemTypes";
import ButtonLink from "./ButtonLink";
import EstateItemList from "./EstateItemList";
import { addEstateItemPath } from "./estateLinks";

// A column, so the Add link fills the form's width as its buttons do
const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--juno-space-4);
`;

// What a request row shows under its gate question once the answer is Yes: the case's items of the
// row's types, and Add while the request is open
const EstateItemRow = ({ kase, row, doableId, canAdd, back }) => (
  <Row>
    <EstateItemList kase={kase} types={row.listedTypes ?? row.itemTypes} label={row.listLabel} />
    {canAdd && (
      <ButtonLink
        to={addEstateItemPath(kase.case_reference, row.itemTypes, `/dashboard/doable/${doableId}`)}
        state={back && { back }}
      >
        {addFormCopy(row.itemTypes).addLabel}
      </ButtonLink>
    )}
  </Row>
);

export default EstateItemRow;
